import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  button: {
    width: theme.spacing(25),
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(1.5),
  },
  container: {
    marginTop: theme.spacing(4.5),
    marginRight: theme.spacing(6),
    marginLeft: theme.spacing(6),
  },
  header: { marginBottom: theme.spacing(2) },
  modalFooter: { display: 'flex', justifyContent: 'center', width: '100%', margin: 'auto' },
  searchBox: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(3),
    marginTop: theme.spacing(9),
    marginBottom: theme.spacing(2),
    alignItems: 'center',
  },
  submitButton: {
    height: theme.spacing(7),
    width: theme.spacing(16),
  },
}));
